__turbopack_context__.v({
  "embedHtml": "PlasmicTerms-module__nGlFZa__embedHtml",
  "freeBox": "PlasmicTerms-module__nGlFZa__freeBox",
  "primaryButton": "PlasmicTerms-module__nGlFZa__primaryButton",
  "root": "PlasmicTerms-module__nGlFZa__root",
  "rootglobal_themePurpleDark_override": "PlasmicTerms-module__nGlFZa__rootglobal_themePurpleDark_override",
  "svg___5KOtg": "PlasmicTerms-module__nGlFZa__svg___5KOtg",
  "svg__yvgqE": "PlasmicTerms-module__nGlFZa__svg__yvgqE",
  "text": "PlasmicTerms-module__nGlFZa__text",
  "textglobal_themeOrange_override": "PlasmicTerms-module__nGlFZa__textglobal_themeOrange_override",
});
